<template>
  <div class="footer clearfix">
    <div class="footer-main">
      <div class="footer-record">
        <a href="http://www.jsdsgsxt.gov.cn/mbm/entweb/elec/certView.shtml?siteId=301146c087f2499ca507bfa91ab143ec" target="_blank"><img src="./../../assets/bei2.png" alt="" border="0"></a>
        &nbsp;
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002001776" target="_blank"><img src="./../../assets/bei1.png" alt="" border="0"></a>
        <span>苏公网安备 32059002001776号    增值电信业务经营许可证：苏B2-20140496    <a href=" https://beian.miit.gov.cn/" target="_blank">苏ICP备14006450号-3</a></span>
      </div>
      <div class="footer-juhe">天聚地合（苏州）科技股份有限公司©版权所有</div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.footer
  line-height 40px
  .footer-main
    max-width 1180px
    width 100%
    margin 0 auto
    color #aaa
    > div
      float left
    .footer-record
      > img:first-child
        width 15px
        height 20px
        margin-right 10px
      > img:last-child
        width 18px
        height 20px
        margin-right 14px
      > span
        font-size 12px
        margin-left 14px
    .footer-juhe
      font-size 12px
      float right
</style>
